"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _InlineSvg = _interopRequireDefault(require("../../../../components/InlineSvg"));

var _LoadingIndicator = _interopRequireDefault(require("../../../../components/LoadingIndicator"));

var _messageStreams = require("../../../reducers/messageStreams");

var _helpers = require("../../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var svgHelper = {
  'Premise underpinning communications': 'star',
  'Creative Strategy': 'brush',
  'Message Promise': 'envelope',
  'Value Proposition': 'stats',
  'Brand Voice': 'megaphone',
  'Key Triggers': 'target',
  'Creative Prerequisites': 'creative',
  'Message prerequisites': 'paperplane',
  'Advertising Tone & Style': 'document',
  'Key Drivers': 'key',
  'Hot Buttons': 'fire',
  'Turn Offs': 'nogo',
  Attitudes: 'bag',
  'Attraction to New things': 'pram',
  'Position on Social issues': 'people',
  'Technology Adoption': 'target',
  'Message Helix Personas': 'people'
};

function CreativeBriefs() {
  var _useSelector = (0, _reactRedux.useSelector)(_messageStreams.messagesSelector),
      sections = _useSelector.sections,
      firstTab = _useSelector.firstTab,
      isFetching = _useSelector.isFetching;

  var _useState = (0, _react.useState)(firstTab),
      currentTab = _useState[0],
      setCurrentTab = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      firstLoading = _useState2[0],
      setFirstLoading = _useState2[1];

  (0, _react.useEffect)(function () {
    setCurrentTab(firstTab);
    setFirstLoading(true);
  }, [firstTab]);

  var renderMessageButton = function renderMessageButton(section, i) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: i,
      onClick: function onClick() {
        return setCurrentTab(section.label);
      },
      className: currentTab === section.label ? 'creative-briefs-menu__item creative-briefs-menu__item--active' : 'creative-briefs-menu__item'
    }, /*#__PURE__*/_react["default"].createElement(_InlineSvg["default"], {
      name: svgHelper[section.label]
    }), /*#__PURE__*/_react["default"].createElement("span", null, section.label));
  };

  var sectionsToDisplay = [];

  if (sections && (0, _helpers.isNZHelix)()) {
    sectionsToDisplay = sections.filter(function (x) {
      return x.label.toLowerCase() !== 'creative prerequisites' && x.label.toLowerCase() !== 'message prerequisites';
    });
  } else if (sections) {
    sectionsToDisplay = sections;
  }

  var subsection = sectionsToDisplay && sectionsToDisplay.length && sectionsToDisplay.find(function (section) {
    return section.label === currentTab;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs-page"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs-menu-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs-menu"
  }, firstLoading ? sectionsToDisplay && sectionsToDisplay.length && sectionsToDisplay.map(renderMessageButton) : /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs-page-content single-persona"
  }, isFetching ? /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, subsection && subsection.messages && subsection.messages.map(function (message, i) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: i
    }, message);
  }), subsection && subsection.additionalMessage && /*#__PURE__*/_react["default"].createElement("p", null, subsection.additionalMessage))));
}

var _default = CreativeBriefs;
exports["default"] = _default;